<template>
    <div id="myCars">
        <v-dialog class="justify-center" v-model="addCarDialog" max-width="500">
            <!-- <v-container class="justify-center"> -->
                <!-- <v-row>
                    <v-col cols="12"> -->
                        <v-card>
                <v-card-title class="headline">Dodawaine pojadu</v-card-title>
                <v-card-title class="subtitle-2">Uzupełnij poniższy formularz w celu dodania pojazdu</v-card-title>
                <v-card-text>
                    <v-col cols="12">
                         <v-text-field :rules="[ruler,nameRules]" label="Marka" v-model="producer" required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                         <v-text-field :counter="10" :rules="[ruler,nameRules]" label="Model" v-model="model"  required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field 
                        label="Pojemność w cm3"
                        v-model="capacity" 
                        type="number" 
                        min="0" 
                        max="10000" 
                        suffix="cm3" 
                        required
                        :rules="[ruler]"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                         <v-text-field 
                         v-model="yearOfProduction" 
                         label="Rok produkcji" 
                         type="number" 
                         min="1930" 
                         max="2020"
                         :rules="[ruler]"
                         ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="d-flex">
                         <v-select
                            :items="['Benzyna', 'Diesel', 'Gaz']"
                            label="Rodzaj paliwa"
                            v-model="fuel" 
                            required
                            :rules="[ruler,nameRules]"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" class="d-flex">
                         <v-select
                            :items="transmissionItem"
                            label="Napęd"
                            v-model="transmission" 
                            required
                            :rules="[ruler,nameRules]"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" class="d-flex">
                        <v-select
                        :items="chipTuningItem"
                        item-text="text"
                        item-value="value"
                        :hint="`${chipTuningItem.text}`"
                        label="Doładowany"
                        v-model="chipTuning" 
                        required
                        :rules="[ruler,nameRules]"
                    ></v-select>
                    </v-col>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                        color="#FF5752"
                        text
                        @click="dialog = false"
                    >
                        Cofnij
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color='#76EB6C'
                        class="white--text"
                        outlined
                        @click="addCars"
                    >
                        <v-icon left>save</v-icon>
                        <span>Zapisz</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
                    <!-- </v-col>
                </v-row> -->
            <!-- </v-container> -->
        </v-dialog>
        <v-container class="justify-center mt-4">
            <v-row class="justify-center">
                <h1>Moje pojazdy</h1>
            </v-row>
            <v-row width="100%" class="d-flex justify-content-end">
                <v-col cols="12" style="text-align:right;">
                    <v-btn
                        color="#76EB6C"
                        dark
                        top
                        right
                        large   
                        @click="addCarDialog = !addCarDialog"
                        >
                        <v-icon left>mdi-plus</v-icon>
                        <span>Dodaj auto</span>
                    </v-btn>
                 </v-col>
             </v-row>
            <v-row class="d-flex justify-center">
                <v-col cols="12" sm="12" md="6">
                    <v-card class="my-3 mx-auto" max-width="800" v-for="(item,index) in cars" :key="index" elevation="8">
                        <v-row class="np-gutters">
                            <v-col cols="12" sm="12">
                                <v-card-title>{{ item.carManufacture }} {{ item.carModel }}</v-card-title>
                        <v-card-subtitle class="pb-0">Rok produckji: {{ item.carYear }}</v-card-subtitle>
                            </v-col>
                        </v-row>
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="12" md="6">
                                <div class="d-flex flex-column">
                                    <v-card-text class="text--primary">
                                        <div>Paliwo: {{ item.carFuel }}</div>
                                        <div>Napęd: {{ item.carDrive }}</div>
                                        <div>Pojemność: {{ item.carEngineCapacity }} cm3</div>
                                        <div>Doładowany: {{ item.carBoosted ? 'Tak' : 'Nie' }}</div>
                                    </v-card-text>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <div>
                                    <v-card-img>
                                        <v-img contain :src="item.carImage"></v-img>
                                    </v-card-img>
                                </div>
                            </v-col>
                        </v-row>
                        
                        <v-card-actions class="editAction">
                            <v-btn
                                color="#FFD700"
                                fab
                                x-small
                                text
                            >   
                                <v-icon>fa-pencil-alt</v-icon>
                            </v-btn>
                            <v-btn
                            color="#FF5752"
                            fab
                            x-small
                            text
                            @click="deleteCar(item.carId)"
                            >   
                                <v-icon>fa-trash-alt</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name:'mycars',
    components:{},
    data(){
        return{
            nameRules: [
                v => v.length <= 3 || 'Minimum 3 znaki',
            ],
            ruler: [
                v => !!v || 'To pole jest wymagane',
            ],
            addCarDialog:false,
            editCarDialog:false,
            picker:false,
            menu:false,
            producer:'',
            model:'',
            yearOfProduction:'',
            capacity:'',
            transmission:'',
            fuel:'',
            chipTuning:'',
            transmissionItem:['FWD', 'RWD', 'AWD'],
            chipTuningItem:[{text:'Tak', value: true},{text:'Nie',value:false}]
        }
    },
    computed:{
        cars(){
            return this.$store.state.userData.cars;
        }
    },
    methods:{
        deleteCar(id){
           this.$store.state.userData.cars = this.$store.state.userData.cars.filter(item=>{
                return item.carId != id;
            });
        },
        addCars(){
            // var newId = this.cars.length;
            // this.$store.userData.cars.push({
            //     carId:newId,
            //     carManufacture:this.producer,
            //     carModel: this.model,
            //     carYear: this.yearOfProduction,
            //     carFuel: this.fuel,
            //     carDrive: this.transmission,
            //     carEngineCapacity: this.capacity,
            //     carBoosted:this.chipTuning
            // });
            this.addCarDialog = !this.addCarDialog;
            setTimeout(()=>{
                alert("dodano nowe auto do bazy");
            },1000) 
        }

    }
    
}
</script>
<style>
    .editAction{
        position: absolute;
        top: 10px;
        right:10px;
    }
</style>